/**
 * Grille équipe de la cave — Vignerons de la Cave de Pierrefeu
 * Lit un Google Sheet publié en CSV (colonnes : Nom, Poste, Photo)
 */
(function () {
  function init(root) {
    var sheetUrl = root.dataset.sheetUrl;
    if (!sheetUrl || typeof Papa === "undefined") return;

    Papa.parse(sheetUrl, {
      download: true,
      header: true,
      skipEmptyLines: true,
      transformHeader: function (h) { return h.replace(/^\uFEFF/, "").trim(); },
      transform: function (v) { return typeof v === "string" ? v.trim() : v; },
      complete: function (results) {
        var rows = results.data.filter(function (r) { return r["Nom"]; });
        var grid = root.querySelector("[data-eq-grid]");
        grid.innerHTML = rows
          .map(function (r) {
            var photo = r["Photo"]
              ? '<img src="' + r["Photo"] + '" alt="' + r["Nom"] + '" loading="lazy">'
              : "";
            return (
              '<div class="eq-card">' +
              '<div class="eq-photo">' + photo + "</div>" +
              '<p class="eq-name">' + r["Nom"] + "</p>" +
              (r["Poste"] ? '<p class="eq-role">' + r["Poste"] + "</p>" : "") +
              "</div>"
            );
          })
          .join("");
      }
    });
  }

  document.querySelectorAll("[data-equipe-cave]").forEach(init);
})();